// extracted by mini-css-extract-plugin
var _1 = "cVoiG";
var _2 = "Fw3cc";
var _3 = "Chg03";
export { _1 as "locationSwitcher", _2 as "rotate", _3 as "spin" }
